export const SET_LOADING = "SET_LOADING";
export const SET_ERRORS = "SET_ERRORS";
export const SET_FILTERS = "SET_FILTERS";
export const SET_OPEN_MODAL = "SET_OPEN_MODAL";
export const SET_EXT_CUSTOM_COLUMN_QUERY = "SET_EXT_CUSTOM_COLUMN_QUERY";

export const GET_EXT_CUSTOM_COLUMN_QUERIES = "GET_EXT_CUSTOM_COLUMN_QUERIES";
export const GET_EXT_CUSTOM_COLUMN_QUERIES_SUCCESS = "GET_EXT_CUSTOM_COLUMN_QUERIES_SUCCESS";
export const GET_EXT_CUSTOM_COLUMN_QUERIES_FAILURE = "GET_EXT_CUSTOM_COLUMN_QUERIES_FAILURE";

export const GET_EXT_CUSTOM_COLUMN_QUERY = "GET_EXT_CUSTOM_COLUMN_QUERY";
export const GET_EXT_CUSTOM_COLUMN_QUERY_SUCCESS = "GET_EXT_CUSTOM_COLUMN_QUERY_SUCCESS";
export const GET_EXT_CUSTOM_COLUMN_QUERY_FAILURE = "GET_EXT_CUSTOM_COLUMN_QUERY_FAILURE";

export const CREATE_EXT_CUSTOM_COLUMN_QUERY = "CREATE_EXT_CUSTOM_COLUMN_QUERY";
export const CREATE_EXT_CUSTOM_COLUMN_QUERY_SUCCESS = "CREATE_EXT_CUSTOM_COLUMN_QUERY_SUCCESS";
export const CREATE_EXT_CUSTOM_COLUMN_QUERY_FAILURE = "CREATE_EXT_CUSTOM_COLUMN_QUERY_FAILURE";

export const UPDATE_EXT_CUSTOM_COLUMN_QUERY = "UPDATE_EXT_CUSTOM_COLUMN_QUERY";
export const UPDATE_EXT_CUSTOM_COLUMN_QUERY_SUCCESS = "UPDATE_EXT_CUSTOM_COLUMN_QUERY_SUCCESS";
export const UPDATE_EXT_CUSTOM_COLUMN_QUERY_FAILURE = "UPDATE_EXT_CUSTOM_COLUMN_QUERY_FAILURE";

export const DELETE_EXT_CUSTOM_COLUMN_QUERY = "DELETE_EXT_CUSTOM_COLUMN_QUERY";
export const DELETE_EXT_CUSTOM_COLUMN_QUERY_SUCCESS = "DELETE_EXT_CUSTOM_COLUMN_QUERY_SUCCESS";
export const DELETE_EXT_CUSTOM_COLUMN_QUERY_FAILURE = "DELETE_EXT_CUSTOM_COLUMN_QUERY_FAILURE";

export const UPDATE_EXT_CUSTOM_COLUMN_QUERIES_ORDER = "UPDATE_EXT_CUSTOM_COLUMN_QUERIES_ORDER";
export const UPDATE_EXT_CUSTOM_COLUMN_QUERIES_ORDER_SUCCESS = "UPDATE_EXT_CUSTOM_COLUMN_QUERIES_ORDER_SUCCESS";
export const UPDATE_EXT_CUSTOM_COLUMN_QUERIES_ORDER_FAILURE = "UPDATE_EXT_CUSTOM_COLUMN_QUERIES_ORDER_FAILURE";